import React, { useEffect, useState } from 'react';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Box, Button, Card, CardContent, Modal, Typography } from '@mui/material';
import { COLOR_TOOLTIP_BACKGROUND } from 'src/utils/const';
import { COLOR_PRIMARY_1, COLOR_PRIMARY_2 } from 'src/utils/colors';

const InfoTooltipContent = ({
  title,
  content,
}: {
  title?: string | JSX.Element;
  content: string | JSX.Element;
}) => {
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down(900));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isMobileDevice) {
      setOpen(true);
    }
  }, [isMobileDevice]);

  const contentComponent = (
    <>
      {title && (
        <Typography variant="h6" color="text.primary" gutterBottom sx={{ fontSize: '16px' }}>
          {title}
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
        {content}
      </Typography>
    </>
  );

  if (isMobileDevice) {
    return (
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Card
          sx={{
            width: '80vw',
            maxWidth: '600px',
            backgroundColor: COLOR_TOOLTIP_BACKGROUND,
            position: 'relative',
            padding: '20px',
          }}
        >
          <CardContent sx={{ padding: '0 !important', paddingBottom: '50px !important' }}>
            {contentComponent}
          </CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '16px',
              position: 'absolute',
              bottom: '20px',
              right: '20px',
            }}
          >
            <Button
              onClick={() => setOpen(false)}
              sx={{
                backgroundColor: COLOR_PRIMARY_1,
                color: '#fff',
                textTransform: 'uppercase',
                fontWeight: 600,
                padding: '5px 20px',
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: COLOR_PRIMARY_2,
                  opacity: 0.9,
                },
              }}
            >
              Close
            </Button>
          </Box>
        </Card>
      </Modal>
    );
  }

  return (
    <Card
      sx={{
        width: '400px',
        backgroundColor: COLOR_TOOLTIP_BACKGROUND,
        padding: '20px',
      }}
    >
      <CardContent sx={{ padding: '0 !important' }}>{contentComponent}</CardContent>
    </Card>
  );
};

export default InfoTooltipContent;
